<template>
<div class="filter-body" >
    <div class="form-group"><label for=""> SKU/Parent/Barcode</label>
        <input name="sku" class="form-control" data-error="Invalid SKU format" placeholder="Enter SKU" type="text">
        <div class="help-block form-text with-errors form-control-feedback"></div>
    </div>
    <div class="form-group"><label for=""> Category</label>
        <select name="category_name" class="form-control select2" multiple="true">
            <option v-for="(index, filter) in filters.category_name" :value="filter">{{filter}}</option>
        </select>
    </div>
    <div class="form-group"><label for=""> Gender</label>
        <select name="gender" class="form-control select2" multiple="true">
            <option v-for="(index, filter) in filters.gender" :value="filter">{{filter}}</option>
        </select>
    </div>
    <div class="form-group"><label for=""> Brand</label>
        <select name="brand" class="form-control select2" multiple="true">
            <option v-for="(index, filter) in filters.brand" :value="filter">{{filter}}</option>
        </select>
    </div>
    <div class="form-group"><label for=""> Season</label>
        <select name="season" class="form-control select2" multiple="true">
            <option v-for="(index, filter) in filters.season" :value="filter">{{filter}}</option>
        </select>
    </div>
    <!-- <div class="form-group"><label for=""> Brand</label>
        <select name="brand[]" class="form-control select2" multiple="true">
            <option v-for="(filter,index) in genderFilters" :value="filter">{{filter}}</option>
        </select>
    </div>
    <div class="form-group"><label for=""> Gender</label>
        <select name="gender[]" class="form-control select2" multiple="true">
            <option v-for="(filter,index) in genderFilters" :value="filter">{{filter}}</option>
        </select>
    </div> -->
</div>
</template>

<script>

export default {
  props: ['filters', 'selectedFilters'],
  watch: {
    filters() {
      setTimeout(function () {
        $('.select2').select2()
      }, 1000)
    }
  }

}
</script>

<style scoped>

</style>
